import { render, staticRenderFns } from "./LlLawListItem.vue?vue&type=template&id=2fe12bf8&scoped=true"
import script from "./LlLawListItem.vue?vue&type=script&lang=js"
export * from "./LlLawListItem.vue?vue&type=script&lang=js"
import style0 from "./LlLawListItem.vue?vue&type=style&index=0&id=2fe12bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe12bf8",
  null
  
)

export default component.exports